import type { ReactNode } from 'react'

import type { jsx } from '@emotion/react'
import { isNil } from 'ramda'
import type { FieldValues, UseFormReturn } from 'react-hook-form'

import type {
  CastedFormValues,
  CastedSubmitHandler,
} from '@twisto/components/atoms/form'
import { Form } from '@twisto/components/atoms/form'

import { useSubmittingWrapper } from '../flow-hooks'

export type Props<T extends FieldValues> = {
  children: ReactNode
  onSubmit?: CastedSubmitHandler<T>
  nativeFormProps?: jsx.JSX.IntrinsicElements['form']
  testId?: string
} & UseFormReturn<T>

export const FlowForm = <T extends FieldValues>({
  onSubmit,
  children,
  ...formContext
}: Props<T>) => {
  const submittingWrapper = useSubmittingWrapper()

  const handleSubmit: CastedSubmitHandler<T> | undefined = !isNil(onSubmit)
    ? async (data: CastedFormValues<T>) => submittingWrapper(onSubmit(data))
    : undefined

  return (
    <Form onSubmit={handleSubmit} {...formContext}>
      {children}
    </Form>
  )
}
